<div class="calendar-schedule flex flex--column g-medium ps-large rounded-large">
  <div class="calendar-schedule__calendar flex-1 flex--basis0">
    @if (openWithParams(); as params) {
      <fin-price-calendar
        [openWithParams$]="params | finToObservable"
        [displayMonths]="1"
        [embedded]="true"
        [showAddReturn]="true"
        [fetchPricesInSSR]="false"
        [ctaLabel]="'timetable.panel.bookFlights' | finLocalization"
        (ctaClicked)="onBookFlights($event)"
      />
    }
  </div>

  <div class="calendar-schedule__timetable flex-1 flex--basis0">
    <fin-timetable-schedule-panel
      [departureBounds]="departureBounds()"
      [departureLoading]="departureLoading()"
      [departureOriginCode]="hasSelectedDate() ? origin() : undefined"
      [departureDestinationCode]="hasSelectedDate() ? destination() : undefined"
      [returnBounds]="returnBounds()"
      [returnLoading]="returnLoading()"
      [returnOriginCode]="hasReturnDate() ? destination() : undefined"
      [returnDestinationCode]="hasReturnDate() ? origin() : undefined"
      [showReturnTab]="showReturnTab()"
    />
  </div>
</div>
